import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Spinner, Table } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import Pagination from '../../Pagination';

const AI_CompanyJobs = () => {
    const BASE_API_URL = process.env.REACT_APP_API_URL;
    const location = useLocation();
    const navigate = useNavigate();
    const userEmail = location.state?.userEmail;
    const userName = location.state?.userName;

    const [error, setError] = useState('')
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const currentPage = location.state?.currentPage || 0;
    const currentPageSize = location.state?.currentPageSize || 6;

    const [page, setPage] = useState(currentPage);
    const [pageSize, setPageSize] = useState(currentPageSize);
    const isLastPage = page === totalPages - 1;
    const isPageSizeDisabled = isLastPage;
    // const fetchAI_CompanyJobs = async () => {
    //     try {
    //         setLoading(true);
    //         const response = await axios.get(`${BASE_API_URL}/scrapeJobsUsingCompany`, {
    //             params: { userEmail },
    //         });
    //         setJobs(response.data || []);
    //     } catch (error) {
    //         console.error('Error fetching jobs data:', error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };



    // useEffect(() => {
    //     if (userEmail) fetchAI_CompanyJobs();
    // }, [userEmail]);
    const userFromLocalStorage = JSON.parse(localStorage.getItem('user'));
    const companyName = userFromLocalStorage?.companyName;

    // useEffect(() => {
    //     if (!companyName) return;

    //     setLoading(true);
    //     axios.get(`${BASE_API_URL}/scrapeJobsUsingCompany`, {
    //         params: { companyName },
    //     })
    //         .then(res => {
    //             setJobs(res.data.jobs || []); // or res.data depending on structure
    //             setTotalPages(res.data.totalPages || 1); // default fallback to 1 if undefined
    //         })
    //         .catch(error => {
    //             console.error(error);
    //             setError("Unable to fetch job listings at the moment.");
    //         })
    //         .finally(() => setLoading(false));
    // }, [companyName]);

    useEffect(() => {
        if (!companyName) return;

        setLoading(true);

        axios.get(`${BASE_API_URL}/scrapeJobsUsingCompany`, {
            params: {
                companyName,
                page,
                size: pageSize,
            },
        })
            .then(res => {
                setJobs(res.data.jobs || []);
                setTotalPages(res.data.totalPages || 1);
            })
            .catch(error => {
                console.error(error);
                setError("Unable to fetch job listings at the moment.");
            })
            .finally(() => setLoading(false));
    }, [companyName, page, pageSize]);

    const handlePageSizeChange = (e) => {
        const size = parseInt(e.target.value);
        setPageSize(size);
        setPage(0); // Reset page when page size change
    };

    const handlePageClick = (data) => {
        const selectedPage = data.selected;
        setPage(selectedPage);

    };
    return (
        <div className="container mt-4">
            {/* Optional header */}
            {/* <h3 className="mb-4 text-center">Jobs Matching Your Company: {userName}</h3> */}

            {loading ? (
                <div className="text-center">
                    <Spinner animation="border" role="status" />
                    <p>Loading jobs...</p>
                </div>
            ) : jobs.length === 0 ? (
                <div className="text-center">
                    <h5>No jobs found based on your company profile.</h5>
                    <p>Try broadening the filters or check back later.</p>
                </div>
            ) : (
                <>
                    <div className="table-details-list table-wrapper">
                        <Table hover responsive >
                            <thead>
                                <tr>
                                    <th>Job Title</th>
                                    <th>Company</th>
                                    <th>Location</th>
                                    <th>Salary</th>
                                    <th>Posted</th>
                                    <th>Source</th>
                                    <th className="text-end">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {jobs.map((job) => (
                                    <tr key={job.id}>
                                        <td className="fw-bold">{job.jobTitle}</td>
                                        <td>{job.companyName}</td>
                                        <td>{job.location}</td>
                                        <td>{job.salary || 'Not disclosed'}</td>
                                        <td>{job.postingDays?.split('T')[0]}</td>
                                        <td>
                                            {job.applyLinksList && Object.entries(job.applyLinksList).length > 0 ? (
                                                Object.entries(job.applyLinksList).map(([title, link], index, array) => (
                                                    <span key={index}>
                                                        <a href={link} target="_blank" rel="noopener noreferrer">
                                                            {title}
                                                        </a>
                                                        {index < array.length - 1 && ', '}
                                                    </span>
                                                ))
                                            ) : (
                                                'No platforms available'
                                            )}
                                        </td>
                                        <td className="text-end">
                                            <Button
                                                variant="primary"
                                                size="sm"
                                                onClick={() =>
                                                    navigate('/hr-dashboard/my-jobs/addJob', {
                                                        state: { userName, userEmail, job },
                                                    })
                                                }
                                            >
                                                Post in Jobbox
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>

                    {/* Pagination */}
                    <Pagination
                        page={page}
                        pageSize={pageSize}
                        totalPages={totalPages}
                        handlePageSizeChange={handlePageSizeChange}
                        isPageSizeDisabled={isPageSizeDisabled}
                        handlePageClick={handlePageClick}
                    />
                </>
            )}
        </div>
    );
};

export default AI_CompanyJobs;
